import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class InventorySupplierXrefBus extends BaseBus
{
    constructor(data: InventorySupplierXrefBus) {
        super(data);
    }

    CID(): any {
        return this.inventorySupplierXrefid;
    }
    initialize(data: InventorySupplierXrefBus) {
        super.initialize(data);
        this.insertDt = CommonFunctions.getDate(data.insertDt);
        this.updateDt = CommonFunctions.getDate(data.updateDt);
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null, parentId: any = null, other: any = null) {
    }
    setFromForm(data: InventorySupplierXrefBus) {
        super.setFromForm(data);
        let dateNow = CommonFunctions.getDateNow();

        if (this.hasId) {
            //this.updateDt = dateNow;
            this.insertDt = data.insertDt;
            this.insertUserId = data.insertUserId;
        }
        else {
            this.insertDt = dateNow;
            this.insertUserId = data.insertUserId;
        }
        this.updateDt = new Date();
    }
    setId(id: any) {
        this.inventorySupplierXrefid = id;
    }

    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        // this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);
    }
    setCommon(userId: any, date: Date, companyId: any = null) {
        if (this.hasId) {
            this.updateUserId = userId;
        }
        else {
            this.insertDt = date;
            this.insertUserId = userId;
             this.updateUserId = userId;
        }

    }
    supplierName: string;
    inventorySupplierXrefid: string;
    supplierId: string;
    inventoryId: string;
    partNumber: string;
    currentCost: number;
    currentCostDate: Date;
    lastCost: number;
    lastCostDate: number;
    contractPrice: number;

    insertDt: Date;
    updateDt: Date;
    updateUserId: string;
    insertUserId: string;
    isMerged: boolean;
    get canEdit(): boolean {
        let can: boolean = true;
        return can;
    }
}
